import { Vector2Tuple } from 'three';

import { MeasurementShallowNode } from '@spazious/dollhouse-shallow-graph';

import { FNodeTypesEnum, MeasurementNode } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class MeasurementNodeImpl extends BaseNodeImpl implements MeasurementNode {
  type: FNodeTypesEnum.Measurement = FNodeTypesEnum.Measurement;
  shallow: MeasurementShallowNode | null = null;
  id: number = 0;
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  points: Vector2Tuple[] = [];
  visible: boolean = true;
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      visible: this.visible,
      shallow: this.shallow,
      points: this.points,
    };
  }
}
